<template>
  <div ref="webSassImgIframeRef"></div>
</template>

<script>
export default {
  name: "WebSassImgIframe",
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      errorText: false,
      webSassImgIframeRef: null
    };
  },
  watch: {
    url: {
      handler(url) {
        url && this.$nextTick(() => this.showImg(url))
      },
      immediate: true
    }
  },
  methods: {
    showImg(url) {
      const img = document.createElement("img");
      img.src = url;
      img.style = "display: block; max-width: 100%; height: 100%; max-height: 100%; object-fit: contain;";
      img.alt = "image 404 not found";
      const iframe = window.document.createElement("iframe")
      iframe.src = "javascript:parent.img;";
      iframe.style.border = "none";
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.onload = function () {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        iframeDocument.body.style = "margin: 0;"
        iframeDocument.body.appendChild(img);
      };
      this.$refs.webSassImgIframeRef.innerHTML = ''
      this.$refs.webSassImgIframeRef.appendChild(iframe);
    }
  }
};
</script>
